import axios from "axios";

import { HEALTHCARE_API } from "@modules/common/constants";

interface OrderActionResponse {
  order: { orderId: string };
}

export const confirmOrderAction = async (
  accessCode: string,
  accessToken: string,
  orderId: string,
  endpoint: string
): Promise<OrderActionResponse> =>
  (
    await axios.post<OrderActionResponse>(
      `${HEALTHCARE_API}/v1/patient/${accessCode}/medicalOrders/${orderId}/${endpoint}`,
      {},
      { headers: { Authorization: `bearer ${accessToken}` } }
    )
  ).data;
